export default __webpack_public_path__ + "static/media/80.c001405e.svg";